import {useState, useEffect, Fragment} from "react";
import {MIN_DESKTOP_SIZE} from "../../constants/global";

export default function DesktopSize({children}) {

    const [isDesktop, setIsDesktop] = useState(false);
    const [initial, setInitial] = useState(false);

    useEffect(() => {
        if (!initial) {
            handleWindowSizeChange();
            setInitial(true);
        }

        window.removeEventListener('resize', handleWindowSizeChange);
        window.addEventListener('resize', handleWindowSizeChange);

        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        };
        // eslint-disable-next-line
    }, [isDesktop]);

    const handleWindowSizeChange = () => {
        if (!isDesktop && window.screen.width >= MIN_DESKTOP_SIZE) {
            setIsDesktop(true);
        } else if (isDesktop && window.screen.width < MIN_DESKTOP_SIZE) {
            setIsDesktop(false);
        }
    }

    return (
        <Fragment>
            {
                isDesktop ? children : null
            }
        </Fragment>
    )

}
